var Curriculog = Curriculog || {};

Curriculog.Entity = (function ($, _, Backbone, Entity) {

	Entity = Curriculog.CurriculogModel.extend({
		removeFromList: function(listName, id) {
			var list = this.get(listName);
			var listIndex = list.indexOf(id);
			if (listIndex >= 0) {
			  this.get(listName).splice( listIndex, 1 );
			}
		}
	});
	return Entity;

})($, _, Backbone, Curriculog.Entity || {});
